import React from 'react';
interface WelcomeScreenProps {
  onNext: () => void;
}
export function WelcomeScreen({
  onNext
}: WelcomeScreenProps) {
  return <div className="flex flex-col min-h-[calc(100vh-64px)] relative bg-stone-900 text-white overflow-hidden" data-id="element-147">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0 opacity-55 bg-cover bg-center" style={{
      backgroundImage: 'url("https://cdn.magicpatterns.com/uploads/mFsP1etRUhJzaGiGTrZAuK/823567245b2519c782a61876784a31e3.jpg")',
      backgroundPosition: 'center'
    }} data-id="element-148" />
      <div className="absolute inset-0 bg-gradient-to-b from-stone-900/85 via-stone-900/55 to-amber-900/95 z-0" data-id="element-149" />

      <div className="relative z-10 flex flex-col items-center justify-center flex-grow px-6 py-12 text-center max-w-md mx-auto w-full pt-[43px] pb-[43px]" data-id="element-150">
        <div className="mb-8 inline-block px-3 py-1 bg-amber-800/50 border border-amber-700/50 rounded-full text-amber-200 text-xs font-semibold tracking-wide uppercase" data-id="element-151">
          Test Gratuito
        </div>

        <h2 className="text-3xl md:text-4xl font-extrabold leading-tight mb-6 text-stone-50 drop-shadow-lg" data-id="element-152">
          ¿Podés empezar un negocio de sahumerios artesanales esta semana?
        </h2>

        <p className="text-lg text-stone-200 mb-12 font-medium leading-relaxed" data-id="element-153">
          Respondé 5 preguntas rápidas y descubrí qué tipo de emprendedora sos.
        </p>

        <button onClick={onNext} className="w-full bg-amber-600 hover:bg-amber-500 text-white font-bold text-lg py-5 px-8 rounded-2xl shadow-[0_8px_30px_rgb(217,119,6,0.3)] transition-all transform hover:scale-[1.02] active:scale-[0.98] flex items-center justify-center gap-2" data-id="element-154">
          QUIERO DESCUBRIRLO
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-155">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M14 5l7 7m0 0l-7 7m7-7H3" data-id="element-156" />
          </svg>
        </button>
      </div>
    </div>;
}